export const MODAL_DIALOG__BANNER_CODE = 'MODAL_DIALOG__BANNER_CODE';
export const MODAL_DIALOG__EDIT_CUSTOM_THUMBNAIL_BANNER = 'MODAL_DIALOG__EDIT_CUSTOM_THUMBNAIL_BANNER';
